import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { MainModule } from '../main/main.module';
import { SharedModule } from '../main/shared.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, BrowserModule, FormsModule, ReactiveFormsModule, RouterModule, MainModule, SharedModule],
  exports: [LoginComponent],
})
export class AuthModule {}
